import React, { useEffect, useState } from 'react';
import { getDocs, collection, doc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { products } from '../../products';

function ProductAnalytics() {
  const [clicks, setClicks] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchClicks = async () => {
    try {
      const ref = collection(doc(db, 'analytics', 'products'), 'userProducts');
      const snapshot = await getDocs(ref);
      const result = {};
      snapshot.forEach(doc => {
        result[doc.id] = doc.data().count || 0;
      });
      setClicks(result);
    } catch (error) {
      console.error('❌ Error fetching analytics:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClicks();
  }, []);

  return (
    <div className="bg-black min-h-screen text-white p-6">
      <h1 className="text-3xl font-bold mb-6" style={{ color: '#DBAE6E' }}>
        Product Clicks
      </h1>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="flex flex-col gap-4">
          {products.map(product => {
            const clickCount = clicks[String(product.id)] || 0;
            const image = Object.values(product.images)[0]?.[0];
            return (
              <div
                key={product.id}
                className="flex items-center rounded-xl p-4 shadow-lg"
                style={{
                  backgroundColor: '#2d1d00',
                  border: '1px solid #DBAE6E',
                }}
              >
                <img
                  src={image}
                  alt={product.name}
                  className="w-16 h-16 object-cover rounded-lg mr-4"
                />
                <div className="flex-1">
                  <h2 className="text-lg font-semibold" style={{ color: '#f4e9d6' }}>
                    {product.name}
                  </h2>
                </div>
                <div className="text-2xl font-bold min-w-[60px] text-right" style={{ color: '#DBAE6E' }}>
                  {clickCount}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ProductAnalytics;
